import { RefObject } from "react";
import { gerarTokenChatZendesk } from "services/zendesk/zendesk-service";

export function generateCookie(nomeDoCookie, valorDoCookie, duracaoDoCookie) {
  const data = new Date();
  data.setTime(data.getTime() + duracaoDoCookie * 24 * 60 * 60 * 1000);
  const expires = `expires=${data.toUTCString()}`;
  document.cookie = `${nomeDoCookie}=${valorDoCookie};${expires};path=/`;
}

export async function createTokenZendesk() {
  const token = localStorage.getItem('tokenIES')?.slice(7);
  generateCookie('JWT_TOKEN', token, 1);

  const tokenChatZendesk = await gerarTokenChatZendesk();
  localStorage.setItem('tokenZendeskChat', tokenChatZendesk);
}
